import {Injectable} from '@angular/core';
import {NavigationEnd, Router} from "@angular/router";
import {RouteDataService} from "../route-data/route-data.service";
import {filter, map} from "rxjs/operators";

@Injectable()
export class TitleService {

  constructor(
    private _router: Router,
    private _routeDataService: RouteDataService
  ) {
    this._router.events
      .pipe(filter((event) => event instanceof NavigationEnd),
            map(() => this._routeDataService.getCurrentRouteData().title))
      .subscribe((title: string): void => {
        document.title = title ? title + ' - Dashboard' : title;
      });
  }

}
